import { useState } from 'react';
import useMediaQuery from './useMediaQuery';

/** Phone toolbars: filters move behind the Filters button (`LibraryFilterToggle`) into
 * `LibraryFilterSheet`. Matches the `max-width: 720px` toolbar rules in `global.css`, where the
 * Filters button appears, and the Directory kit's toolbar. Page layouts (cards instead of
 * tables, compact headers) keep their own breakpoints, such as `useLibraryPhoneLayout`. */
export const COMPACT_TOOLBAR_QUERY = '(max-width: 720px)';

function matchesNow(query: string): boolean {
  return typeof window !== 'undefined'
    && typeof window.matchMedia === 'function'
    && window.matchMedia(query).matches;
}

/** Reads the query on the first render, so a phone never mounts the inline filters first. */
export default function useCompactToolbar(): boolean {
  const [initial] = useState(() => matchesNow(COMPACT_TOOLBAR_QUERY));
  return useMediaQuery(COMPACT_TOOLBAR_QUERY, initial);
}
